import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HtmlMailCreatorPopoverComponent } from './HtmlMailCreatorPopoverComponent';

/**
 * HtmlMailCreatorModule
 * HTMLメール作成機能のスタンドアロンモジュール
 */
@NgModule({
  declarations: [
    HtmlMailCreatorPopoverComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  exports: [
    HtmlMailCreatorPopoverComponent
  ]
})
export class HtmlMailCreatorModule { }
